var ezdia;
(function (ezdia) {
    function verifierLabelMarkup(verifierCheck, index, textColor) {
        return verifierCheck
            ? "<button\n    data-verifier=\"entity label\"\n    data-index=\"" + index + "\"\n    class=\"action fa fa-check-circle\"\n    type=\"button\"\n    style=\"color: " + textColor + "\"\n    ></button>"
            : '';
    }
    function deleteLabelMarkup(index, editable, textColor) {
        return editable
            ? "<button\n    data-delete=\"entity label\"\n    data-index=\"" + index + "\"\n    class=\"action fa fa-times-circle\"\n    type=\"button\"\n    style=\"color: " + textColor + "\"\n    ></button>"
            : '';
    }
    function labelMarkup(_a) {
        var label = _a.label, type = _a.type, index = _a.index, bgColor = _a.bgColor, textColor = _a.textColor, verifierCheck = _a.verifierCheck, remove = _a.remove;
        return "<span\n      class=\"entity-tag\"\n      style=\"background-color: " + bgColor + "; color: " + textColor + "\"\n      ><span title=" + type + ">" + label + "</span>" + verifierLabelMarkup(verifierCheck, index, textColor) + deleteLabelMarkup(index, remove, textColor) + "</span>";
    }
    function getBtnsMarkup(attributes) {
        var HtmlMarkupArray = [];
        attributes.forEach(function (attribute) {
            var text = attribute.text, bgColor = attribute.bgColor, textColor = attribute.textColor, type = attribute.type, shortcut = attribute.shortcut;
            var btn = "<button\n        class=\"btn btn-sm entity-mark-btn\"\n        type=\"button\"\n        data-type=\"" + type + "\"\n        data-shortcut=\"" + shortcut + "\"\n        style=\"background-color: " + bgColor + "; color: " + textColor + "\"\n      >\n        " + text + "<span class=\"entity-btn-sckey\" \n        style=\"color: " + textColor + "\">" + shortcut + "<span>\n      </button>";
            HtmlMarkupArray.push(btn);
        });
        return HtmlMarkupArray.join('');
    }
    function fieldHtml(_a) {
        var 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        column = _a.column, value = _a.value, attributesMap = _a.attributesMap, contanerID = _a.contanerID, labelsContanerID = _a.labelsContanerID, contentContanerID = _a.contentContanerID, listContanerID = _a.listContanerID, listView = _a.listView;
        var listContaner = '';
        if (listView) {
            listContaner = "<div class=\"panel-footer entity-labeling-list\" id=\"" + listContanerID + "\"></div>";
        }
        return "\n      <div id=\"" + contanerID + "\" class=\"panel panel-default entity-labeling-panel\">\n        <div class=\"panel-heading entity-labeling-labels\" id=\"" + labelsContanerID + "\">\n          " + getBtnsMarkup(attributesMap) + "\n        </div>\n        <div>\n          <div class=\"panel-body entity-labeling-content\" id=\"" + contentContanerID + "\">\n            " + (value.content || '') + "</div>" + listContaner + "\n        </div>\n      </div>";
    }
    function noContentMarkup() {
        return "<div class=\"entity-labeling-nodata-msg\">\n      <div class=\"alert alert-warning\">No content for labeling.</div>\n    </div>";
    }
    function viewLabelingMarkup(htmlContent) {
        return "<div class=\"entity-labeling-panel\">\n      <div class=\"entity-labeling-content\">" + htmlContent + "</div>\n    </div>";
    }
    function listEntity(props) {
        var label = props.label, stringValue = props.stringValue, bgColor = props.bgColor, editable = props.editable, index = props.index, verifierCheck = props.verifierCheck;
        var removebtn = '';
        if (editable) {
            removebtn = "<div>\n        <button class=\"close\" data-index=\"" + index + "\" data-delete=\"entity label\" type=\"button\">&times;</button>\n      </div>";
        }
        return "<li>\n      <div class=\"ann-color\" style=\"background: " + bgColor + "\"></div>\n      <div class=\"ann-lbl\">" + label + ":</div>\n      <div class=\"ann-strval\">" + stringValue + "</div>\n      " + verifierLabelMarkup(verifierCheck, index) + removebtn + "\n    </li>";
    }
    var templates;
    (function (templates) {
        templates.entityLabeling = {
            markup: fieldHtml,
            labelMarkup: labelMarkup,
            noContentMarkup: noContentMarkup,
            viewLabelingMarkup: viewLabelingMarkup,
            listEntity: listEntity
        };
    })(templates = ezdia.templates || (ezdia.templates = {}));
})(ezdia || (ezdia = {}));
